import { render, staticRenderFns } from "./AssetInfo.vue?vue&type=template&id=5af74d54&scoped=true&"
import script from "./AssetInfo.vue?vue&type=script&lang=js&"
export * from "./AssetInfo.vue?vue&type=script&lang=js&"
import style0 from "./AssetInfo.vue?vue&type=style&index=0&id=5af74d54&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5af74d54",
  null
  
)

export default component.exports